import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TopBarNavMenu from './TopBarNavMenu';


class TopBarNav extends Component {
    constructor(props) {
        super(props);
        this.isActive = this.isActive.bind(this);
        this.state = {
            activeIndex: null,
            isActive: false
        }
    }

    isActive = (index) => {
        if (this.state.activeIndex !== index) {
            this.setState({ activeIndex: index });
        }
        else {
            this.setState({ activeIndex: null });
        }
    }

    refreshUserReport(e, reportName) {
        this.setState({ activeIndex: null });
        this.props.getUserSelection(reportName);
    }

    render() {
        return (
            <div id="navbar" className="navbar navbar-expand-sm  navbar-dark" style={{ marginBottom: 0 }}>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul className="nav navbar-nav">
                        {hasPermission(this.props.user.scope, ["Project:View", "Project:Create", "Project:Edit", "Project:Delete"]) &&
                            <TopBarNavMenu name="Project" index={0} isActive={this.state.activeIndex} getActiveIndex={this.isActive}>
                            <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Projects.ProjectSummaryByProjectManager') }}>Project Summary by Project Manager</a>
                                    <div className="dropdown-divider"></div>
                            <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Projects.ProjectsByProjectManager')}}>Projects by Project Manager</a>
                                <div className="dropdown-divider"></div>
                            <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Projects.ClientExpeditingReport') }}>Client Expediting Report</a>
                            </TopBarNavMenu>

                        }
                        {
                            hasPermission(this.props.user.scope, ["PO:View", "PO:Create", "PO:Edit", "PO:Delete"]) &&
                            <TopBarNavMenu name="Purchase Order" index={1} isActive={this.state.activeIndex} getActiveIndex={this.isActive}>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e,'PurchaseOrder.FollowUpCallReportTable')}}>Follow-up Call Report</a>
                            </TopBarNavMenu>
                        }
                        {
                            hasPermission(this.props.user.scope, ["Shipment:View", "Shipment:Create", "Shipment:Edit", "Shipment:Delete"]) &&
                            <TopBarNavMenu name="Shipment" index={2} isActive={this.state.activeIndex} getActiveIndex={this.isActive}>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e,'Shipments.BOLDocument')}}>Bill of Lading</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e,'Shipments.ShipmentChargeSummary')}}>Shipment Charge Summary</a>
                            </TopBarNavMenu>
                        }
                        {
                            hasPermission(this.props.user.scope, ["Inventory:View", "Inventory:Create", "Inventory:Edit", "Inventory:Delete"]) &&
                            <TopBarNavMenu name="Receiving Alert" index={3} isActive={this.state.activeIndex} getActiveIndex={this.isActive}>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'ReceivingAlert.ReceivingAlertDocument')}}>Receiving Alert Document</a>
                            </TopBarNavMenu>
                        }
                        {
                            hasPermission(this.props.user.scope, ["RA:View", "RA:Create", "RA:Edit", "RA:Delete"]) &&
                            <TopBarNavMenu name="Invoices" index={4} isActive={this.state.activeIndex} getActiveIndex={this.isActive}>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e,'Invoices.WarehousingChargeSummary') }}>Warehousing Charge Summary</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Invoices.WarehousingChargeDetail') }}>Warehousing Charge Detail</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault();  this.refreshUserReport(e,'Invoices.WarehousingInvoiceReport') }}>Warehousing Invoice Report</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Invoices.UnbilledShipmentReport') }}>Unbilled Shipment Report</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Invoices.InvoiceSummary') }}>Invoice Summary</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Invoices.CustomerInvoiceSummary') }}>Customer Invoice Summary</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'Invoices.ChargeTypeSummary') }}>Charge Type Summary</a>
                            </TopBarNavMenu>
                        }
                        {
                            hasPermission(this.props.user.scope, ["Inventory:View", "Inventory:Create", "Inventory:Edit", "Inventory:Delete"]) &&
                            <TopBarNavMenu name="Inventory" index={5} isActive={this.state.activeIndex} getActiveIndex={this.isActive}>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e,'Inventory.InventoryStatusReport')}}>Inventory Status Report</a>
                            </TopBarNavMenu>
                        }
                        {
                            hasPermission(this.props.user.scope, ["Inventory:View", "Inventory:Create", "Inventory:Edit", "Inventory:Delete"]) &&
                            <TopBarNavMenu name="Pick Tickets" index={6} isActive={this.state.activeIndex} getActiveIndex={this.isActive}>
                                <a className="dropdown-item dropdown-menutext" href="" onClick={(e) => { e.preventDefault(); this.refreshUserReport(e, 'PickTickets.PickTicketDocument')}}>Pick Ticket Document</a>
                            </TopBarNavMenu>
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

const hasPermission = (claims, permission) => {
    if (claims && permission) {
        if (claims === "Admin") {
            return true;
        }
        if (permission instanceof Array) {
            claims = claims.split(' ');
            // debugger;
            return claims.some(item => {
                return permission.indexOf(item) >= 0
            });
        }
        if (claims && permission) {
            return claims.indexOf(permission) !== -1
        }
    }
    return false;
};


const mapStateToProps = state => ({ user: state.userAuthentication.user });
export default withRouter(connect(mapStateToProps, null)(TopBarNav));